import { IFileUploadSetData } from '@interfaces/mfe/mfe-document-upload.interface';
import { select, Selector, Store } from '@ngrx/store';
import { sanitizeError } from '@shared/helpers/sanitize-error-helper';
import { LoggerCodes } from '@shared/modules/logger/logger';
import { LogError } from '@store/actions';
import { closeSpinner, openSpinner } from '@store/actions/spinner/spinner.actions';
import { IFileMetaData } from '@store/reducers/document-upload/document-upload.reducer';
import { filter, take } from 'rxjs';
import { SubSink } from 'subsink';

export type LoadFetchedFilesOptions = {
  store: Store;
  subs: SubSink;
  selector: Selector<any, IFileMetaData[]>;
  fetchObjectURL: (url: string) => Promise<Blob>;
  docUploadEnableMultipleFiles: boolean;
  onLoaded: (setData: IFileUploadSetData) => void;
  onError?: (error: Error) => void;
};

export function loadFetchedFilesIntoMFE(options: LoadFetchedFilesOptions): void {
  const { store, subs, selector, fetchObjectURL, docUploadEnableMultipleFiles, onLoaded } = options;

  store.dispatch(openSpinner());

  subs.add(
    store
      .pipe(
        select(selector),
        filter((files) => files?.length > 0 && files.every((f) => !!f.objectURL)),
        take(1),
      )
      .subscribe(async (filesMetaData) => {
        try {
          const fileArray: File[] = [];
          for (const fileMetaData of filesMetaData) {
            const blob = await fetchObjectURL(fileMetaData.objectURL);
            fileArray.push(new File([blob], fileMetaData.fileName, { type: blob.type }));
          }
          onLoaded({
            files: fileArray,
            runValidation: false,
            isMultipleFileEnabled: docUploadEnableMultipleFiles,
          });
        } catch (error) {
          store.dispatch(
            LogError({
              payload: {
                eventId: 'error-documents-add-to-mfe-failure',
                message: `Fetch file from S3 Error:${JSON.stringify(sanitizeError(error))}`,
                code: LoggerCodes.NULL_FAILURE,
              },
            }),
          );
        } finally {
          store.dispatch(closeSpinner());
        }
      }),
  );
}
